<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-layout align-center
                  class="mb-8">
            <GetFile :loader="pdfLoader"
                     class="mr-3"
                     @get-file="emitGetFile('pdf')">
            </GetFile>
            <GetFile :title="$t('buttons.export_xls')"
                     :loader="xlsLoader"
                     @get-file="emitGetFile('xls')">
                <template slot="icon">
                    <v-icon class="mr-1"
                            size="20">{{ ICONS.EXPORT }}</v-icon>
                </template>
            </GetFile>
            <v-btn color="secondary"
                   small
                   @click="showSendMail"
                   class="ml-3">{{ $t('buttons.send_mail') }}</v-btn>
            <SendMail :dialog="sendMailVisibility"
                      :callback="sendMail"
                      :default-title="`${$t('labels.inspector_report')}`"
                      @close="closeSendMail"
                      @visibility="sendMailVisibility = $event"></SendMail>
        </v-layout>
        <p class="text--xs mb-1"><span class="red--text font-weight-medium">*</span> {{ $t('messages.marked_incorrect_inspections') }}</p>
        <v-data-table :headers="headers"
                      :loading="loader"
                      :items="inspectionsPerEmployee"
                      disable-pagination
                      hide-default-footer
                      class="elevation-1">
            <template v-for="(headerItem, i) in headers"
                      v-slot:[`header.${headerItem.value}`]="{ header, on }">
                <SortableHeader :header-item="header"
                                v-on="on"
                                :key="i"></SortableHeader>
            </template>

            <template v-slot:item.total="{ item }">
                {{ item.total.count }}/<span class="red--text font-weight-medium">{{ item.total.incorrectCount }}</span>
            </template>

            <template v-for="(i) in 12"
                      v-slot:[`item.month_${i}`]="{ item }">
                <span v-if="item[`month_${i}`].count === 0 && (item.year < item.from_year || i < item.from_month)" :key="i">-</span>
                <span v-else :key="i">
                    {{ item[`month_${i}`].count }}/<span class="red--text font-weight-medium">{{ item[`month_${i}`].incorrectCount }}</span>
                </span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { ICONS } from '@/constants/icons';
import SortableHeader from '@/components/widgets/tables/SortableHeader';
import GetFile from '@/components/widgets/buttons/GetFile';
import SendMail from '@/components/widgets/dialogs/SendMail';

export default {
    name: 'InspectorReportTable',
    components: { SortableHeader, GetFile, SendMail },
    props: {
        loader: {
            type: Boolean,
            'default': false
        },
        xlsLoader: {
            type: Boolean,
            'default': false
        },
        pdfLoader: {
            type: Boolean,
            'default': false
        },
        filters: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        ICONS,
        sendMailVisibility: false
    }),
    computed: {
        ...mapState('reports', [
            'inspectionsPerEmployee'
        ]),
        ...mapState('generalConfigurations', [
            'host'
        ]),
        ...mapFields('sendMail', [
            'mailData.agency',
            'mailData.kindOfReport',
            'mailData.report'
        ]),
        headers () {
            return [
                {
                    text: this.$t('labels.customer'),
                    value: 'customer',
                    sortable: true
                },
                {
                    text: this.$t('labels.site'),
                    value: 'place',
                    sortable: true
                },
                {
                    text: this.$t('labels.location'),
                    value: 'point',
                    sortable: true
                },
                {
                    text: this.$t('labels.amount_per_year'),
                    value: 'total',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.jan'),
                    value: 'month_1',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.feb'),
                    value: 'month_2',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.mar'),
                    value: 'month_3',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.apr'),
                    value: 'month_4',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.may'),
                    value: 'month_5',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.jun'),
                    value: 'month_6',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.jul'),
                    value: 'month_7',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.aug'),
                    value: 'month_8',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.sep'),
                    value: 'month_9',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.oct'),
                    value: 'month_10',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.nov'),
                    value: 'month_11',
                    sortable: false
                },
                {
                    text: this.$t('labels.months.dec'),
                    value: 'month_12',
                    sortable: false
                }
            ];
        }
    },
    methods: {
        emitGetFile (type) {
            this.$emit('get-file', type);
        },
        showSendMail () {
            this.sendMailVisibility = true;
        },
        sendMail () {
            this.agency = this.host;
            this.kindOfReport = 'customers';
            this.report = this.filters;

            return this.$store.dispatch('sendMail/sendReport');
        },
        closeSendMail () {
            this.sendMailVisibility = false;
            this.$store.commit('sendMail/RESET_MAIL_DATA');
        }
    }
};
</script>

<style scoped lang="scss">
    ::v-deep {
        & .v-data-table {
            & table {
                & .v-data-table-header__icon {
                    display: none;
                }
            }
        }
    }
</style>
